/**
 * Place des Arts — pré-remplissage de la page contact depuis l'URL.
 *
 * Appelé par le CTA « Nous contacter » d'une œuvre « sur demande » :
 *   /pages/contact?sujet=prix-sur-demande&oeuvre=<handle>&titre=<titre>
 *
 * ⚠️ POURQUOI DU JS ET PAS DU LIQUID : Shopify n'expose AUCUN lecteur de query string
 * arbitraire en Liquid (il n'existe pas de `request.query_string`). Seuls les paramètres
 * que Shopify modélise lui-même sont lisibles côté serveur (`search.terms` pour ?q=,
 * `results.sort_by`, les `filter.*`). `?sujet=` et `?oeuvre=` n'en font pas partie.
 *
 * ⛔ LE CHAMP CACHÉ EST CRÉÉ PAR CE SCRIPT, JAMAIS RENDU EN DUR PAR LA SECTION.
 * Un `<input type="hidden" name="contact[Oeuvre]">` rendu inconditionnellement ferait
 * partir une ligne « Oeuvre : » VIDE dans CHAQUE e-mail de contact du site — un
 * placeholder shippable, ce que la maison proscrit. Pas de paramètre ⇒ pas de champ.
 *
 * ⛔ NOM DU CHAMP EN ASCII (`contact[Oeuvre]`, pas `contact[Œuvre]`) : c'est la clé qui
 * devient le libellé de la ligne dans l'e-mail reçu par la galerie ; un caractère non
 * ASCII dans un nom de champ de formulaire est une source d'encodage bancal.
 */
(() => {
  const params = new URLSearchParams(window.location.search);
  const sujet = params.get('sujet');
  const handle = params.get('oeuvre');
  const titre = params.get('titre');
  const artiste = params.get('artiste');

  // Rien à faire : ni sujet ni œuvre. On ne touche à rien (page contact ordinaire).
  if (!sujet && !handle) return;

  const form = document.querySelector('.pda-contact__form');
  if (!form) return;

  // ── Sujet ──────────────────────────────────────────────────────────────────
  // La liste des options est ÉDITEUR-OWNED (réglage `subjects`, servi depuis
  // templates/page.contact.json). On ne l'invente pas : on cherche une option qui
  // corresponde, et si elle n'existe pas on laisse le champ tel quel plutôt que
  // d'injecter une valeur que la galerie n'a pas choisie.
  if (sujet === 'prix-sur-demande') {
    const select = form.querySelector('select[name="contact[Sujet]"]');
    if (select) {
      /* ⛔ ON APPARIE SUR LE JETON, PLUS SUR LE LIBELLÉ (débranché le 20/08).
       * C'était `/prix\s+sur\s+demande/i` testé sur le `textContent` de l'option —
       * donc sur un texte que Sam renomme dans l'éditeur et que Translate & Adapt
       * traduit. `data-sujet-slug` est posé par sections/pda-contact.liquid.
       * Le repli sur la regex est CONSERVÉ pour une raison précise : une page
       * contact dont le rendu daterait d'avant ce commit n'a pas l'attribut. Il
       * disparaîtra une fois le thème déployé partout. */
      const cible =
        [...select.options].find((o) => o.value && o.dataset.sujetSlug === sujet) ||
        [...select.options].find((o) => o.value && /prix\s+sur\s+demande/i.test(o.textContent || ''));
      if (cible) {
        select.value = cible.value;
        // `change` : le sélecteur peut être observé (validation, styles d'état).
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // ── L'œuvre concernée ──────────────────────────────────────────────────────
  // Cote Sam : la galerie reçoit le TITRE + le LIEN vers l'œuvre. Le titre seul ne
  // suffit pas (le catalogue porte des homonymes en nombre — c'est ce qui a fait
  // échouer un appariement par titre pendant la conception de ce chantier).
  if (handle) {
    const url = `${window.location.origin}/products/${handle}`;
    const valeur = titre ? `${titre} — ${url}` : url;

    let champ = form.querySelector('input[name="contact[Oeuvre]"]');
    if (!champ) {
      champ = document.createElement('input');
      champ.type = 'hidden';
      champ.name = 'contact[Oeuvre]';
      form.appendChild(champ);
    }
    champ.value = valeur;

    // Confirmation VISIBLE : sans elle, le client ne sait pas que sa demande porte
    // une œuvre précise, et il la retape dans le message. Le champ caché seul est
    // muet pour l'expéditeur alors qu'il est bavard pour le destinataire.
    // Le message nomme l'ARTISTE en plus de l'œuvre (cote Sam 19/08) : le
    // catalogue porte des homonymes en nombre — c'est ce qui a fait échouer un
    // appariement par titre pendant la conception de ce chantier — et la galerie
    // identifie une pièce par son artiste avant son titre.
    // ⛔ L'artiste n'est ajouté QUE s'il est présent : « de  » avec un trou serait
    //    un placeholder shippable, ce que la maison proscrit. Sur ce catalogue
    //    l'artiste est quasi toujours renseigné (repli `vendor`), mais « quasi »
    //    n'est pas « toujours », et c'est le client qui lirait la phrase bancale.
    const zone = form.querySelector('textarea[name="contact[body]"]');
    if (zone && !zone.value && titre) {
      const oeuvre = artiste ? `« ${titre} » de ${artiste}` : `« ${titre} »`;
      zone.value = `Bonjour,\n\nJe souhaite connaître le prix de l'œuvre ${oeuvre}.\n\n`;
    }
  }
})();
